import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14.143 11.486a1 1 0 0 1 1.714 1.028c-1.502 2.505 -2.41 4.89 -2.87 7.65c-.16 .956 -1.448 1.15 -1.881 .283c-2.06 -4.12 -3.858 -4.976 -6.79 -3.998a1 1 0 1 1 -.632 -1.898c3.2 -1.067 5.656 -.373 7.803 2.623l.091 .13l.011 -.04c.522 -1.828 1.267 -3.55 2.273 -5.3l.28 -.478z","key":"svg-0"}],["path",{"d":"M18 4a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z","key":"svg-1"}]]

const IconBounceRightFilled = createReactComponent('filled', 'bounce-right-filled', 'BounceRightFilled', __iconNode);

export default IconBounceRightFilled;